import React from 'react';
import { SolicitationSection } from 'pages/project';
import { ProjectEditorContextProps } from 'pages/project/ProjectEditor/contexts/types';

const Daily: React.FC<ProjectEditorContextProps> = props => {
  return <SolicitationSection requestTable requestType="diaria" {...props} />;
};

export default Daily;
